var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 12 : 6 } },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: "",
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": _vm.$t("range"),
                  "start-placeholder": _vm.$t("createStartTime"),
                  "end-placeholder": _vm.$t("createEndTime")
                },
                model: {
                  value: _vm.value2,
                  callback: function($$v) {
                    _vm.value2 = $$v
                  },
                  expression: "value2"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.isMobile ? 6 : 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("pleaseChoose")
                  },
                  on: { change: _vm.switchSerive },
                  model: {
                    value: _vm.paramsData.is_prod,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "is_prod", $$v)
                    },
                    expression: "paramsData.is_prod"
                  }
                },
                _vm._l(_vm.severlist, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function() {
                      _vm.tableData = []
                      _vm.getList()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addCode.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "admin_name",
              label: _vm.$t("operator"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.admin_name == 0 ? "超管" : row.admin_name || "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "cp_announce_id",
              label: _vm.$t("rdAnnouncementId"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.cp_announce_id
                            ? row.cp_announce_id.toString()
                            : "/" || "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "language",
              label: _vm.$t("announcementType"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.announcementTypes.find(function(i) {
                            return i.value == row.pause
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              label: _vm.$t("title"),
              "show-overflow-tooltip": "",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_c("div", [_vm._v(_vm._s(row.title || "/"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "language",
              label: _vm.$t("language"),
              "min-width": "220"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.language || "/") + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_name",
              label: _vm.$t("serverScope"),
              "min-width": "120",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.server_rangeList &&
                            row.server_rangeList.length > 0
                            ? Array.from(new Set(row.server_rangeList))
                                .map(function(id) {
                                  var item = _vm.serverLists.find(function(i) {
                                    return i.serverID == id
                                  })
                                  return item ? item.serverName : id
                                })
                                .join(", ")
                            : "全部"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_name",
              label: _vm.$t("channel"),
              "min-width": "120",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.formattedChannels &&
                            row.formattedChannels.length > 0
                            ? row.formattedChannels.join(", ")
                            : "全部"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "label",
              label: _vm.$t("identifier"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.tagggList.find(function(i) {
                              return i.value == row.label
                            })
                              ? _vm.tagggList.find(function(i) {
                                  return i.value == row.label
                                }).label
                              : row.label
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "priority",
              label: _vm.$t("priority"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "force_push",
              label: _vm.$t("isStrongReminder"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.force_push == 1
                            ? _vm.$t("yes")
                            : _vm.$t("no")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_del_sign",
              label: _vm.$t("isCovered"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.is_del_sign == 0
                            ? "/"
                            : row.is_del_sign == 1
                            ? _vm.$t("notCovered")
                            : _vm.$t("covered")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "show_switch",
              label: _vm.$t("toggleButton"),
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.pause == 1
                            ? row.show_switch
                              ? _vm.$t("show")
                              : _vm.$t("hide")
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "start_time",
              label: _vm.$t("startTime"),
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.start_time != -1
                            ? scope.row.start_time
                            : _vm.$t("unlimited")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "end_time",
              label: _vm.$t("endTime"),
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          scope.row.end_time != -1
                            ? scope.row.end_time
                            : _vm.$t("unlimited")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "end_time",
              label: _vm.$t("time"),
              "min-width": "300"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.pause == 0 ? _c("div", [_vm._v(" / ")]) : _vm._e(),
                    row.pause == 1
                      ? _c("div", [
                          _vm._v(" " + _vm._s("" + row.pause_start_time) + " ")
                        ])
                      : _vm._e(),
                    row.pause == 2
                      ? _c("div", [
                          _vm._v(" " + _vm._s("" + row.pause_start_time) + " ")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "end_time", label: _vm.$t("content") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "viewText",
                        on: {
                          click: function($event) {
                            return _vm.$refs.richTextDetails.open(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("view")))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "created_at",
              label: _vm.$t("createTime"),
              width: "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.created_at) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updated_at",
              label: _vm.$t("updateTime"),
              width: "200"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "200",
              align: "center",
              fixed: _vm.isMobile ? false : "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.type == "old"
                      ? _c("div", { staticClass: "x-c" }, [
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.addCode.open(row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("modify")))]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" }),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.handleDelete(row.id, row.type)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("delete")))]
                          )
                        ])
                      : _vm._e(),
                    row.type == "new" && row.status == 2
                      ? _c("div", { staticClass: "x-c" }, [
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.sendAnnounced(row.id)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("publish")))]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" }),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.addCode.open(row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("modify")))]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" })
                        ])
                      : _vm._e(),
                    row.status == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "controlsBtn",
                            on: {
                              click: function($event) {
                                return _vm.$refs.coverAnnounce.open(row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("edit")))]
                        )
                      : _vm._e(),
                    row.status == 1
                      ? _c("div", { staticClass: "controlsBtn-vertical" })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "controlsBtn",
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(row.id, row.type)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("delete")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.currentPage,
          total: _vm.tableCopyTableList.length,
          "page-size": _vm.pageSize
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      }),
      _c("addCode", {
        ref: "addCode",
        attrs: {
          prod: { is_prod: _vm.paramsData.is_prod },
          channellAllList: _vm.channelList,
          serverList: _vm.serverLists
        },
        on: { update: _vm.getList }
      }),
      _c("richTextDetails", { ref: "richTextDetails" }),
      _c("coverAnnounce", {
        ref: "coverAnnounce",
        attrs: {
          prod: { is_prod: _vm.paramsData.is_prod },
          channellAllList: _vm.channelList,
          serverList: _vm.serverLists
        },
        on: { update: _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }